export default {
  fillBlanksWithAudio: 'fillBlanksWithAudio',
  fillBlanksWithTranslation: 'fillBlanksWithTranslation',
  matchAudioToWords: 'matchAudioToWords',
  matchWordsToMeanings: 'matchWordsToMeanings',
  matchAudioToMeanings: 'matchAudioToMeanings',
};
